import { ApplicationInsights } from '@microsoft/applicationinsights-web';

function install (Vue, config) {
  Vue.appInsights = new ApplicationInsights({ config });

  const originSiteTelemetry = (envelope) => {
    envelope.data.originSite = process.env.VUE_APP_FUND_NAME;
  };

  Vue.appInsights.addTelemetryInitializer(originSiteTelemetry);

  Vue.appInsights.loadAppInsights();
  if (typeof (config.onAfterScriptLoaded) === 'function') {
    config.onAfterScriptLoaded(Vue.appInsights);
  }

  const router = config.router;

  // Watch route event if router option is defined.
  if (router) {
    if (config.trackInitialPageView !== false) {
      setupPageTracking(config, Vue);
    } else {
      router.onReady(() => setupPageTracking(config, Vue));
    }
  }

  Object.defineProperty(Vue, '$appInsights', {
    get: () => Vue.appInsights
  });
}

/**
 * Track route changes as page views with AppInsights
 * @param options
 */
function setupPageTracking (options, Vue) {
  const router = options.router;

  const baseName = options.baseName || '(Vue App)';

  router.beforeEach((route, from, next) => {
    const name = baseName + ' / ' + route.name;
    Vue.appInsights.startTrackPage(name);
    next();
  });

  router.afterEach(route => {
    const name = baseName + ' / ' + route.name;
    const url = location.protocol + '//' + location.host + route.fullPath;
    Vue.appInsights.stopTrackPage(name, url);
    Vue.appInsights.flush();
  });
}

// auto install for navigator
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(install);
}

export default install;
